import MakeConsumerTransaction from './MakeConsumerTransaction';
export default MakeConsumerTransaction;
